const MARKET_AWARE_PATHS = new Set(["/markets", "/opportunities"]);

const readStoredMarket = (activeOrgId) => {
  try {
    return sessionStorage.getItem(`lodge_dash_market:${activeOrgId || "unknown"}`);
  } catch {
    return null;
  }
};

export const resolveDemoNavPath = ({ path, location, activeOrgId, immutableDemo }) => {
  if (!immutableDemo) return path;

  const params = new URLSearchParams(location?.search || "");
  const view = params.get("view");
  const market = params.get("market") || readStoredMarket(activeOrgId);

  if (path === "/dashboard") {
    if (view === "destination") return "/dashboard?view=destination";
    return market && market !== "FR-WORLD"
      ? `/dashboard?view=market&market=${encodeURIComponent(market)}`
      : "/dashboard?view=destination";
  }

  if (view === "destination" || !MARKET_AWARE_PATHS.has(path) || !market || market === "FR-WORLD") {
    return path;
  }

  return `${path}?market=${encodeURIComponent(market)}`;
};

